import React from "react";
import logo from "../src/Assests/Rise Images/Logo.png";
import { Link, useLocation } from 'react-router-dom';
export default function Header() {
  const location = useLocation();

  const isHomePage = location.pathname === '/'; // Check if you're on the home page


  return (
    <>
      <div className="Container-fluid d-flex" style={{ height: "100px" }}>
        <div className="col-4 d-flex justify-content-center align-items-center">
        </div>

        <div className="logo col-4 d-flex justify-content-center align-items-center ">
        {isHomePage ? (
        <img style={{ width: '270px' }} src={logo} alt="Logo" />
      ) : (
        <Link to="/">
          <img style={{ width: '270px' }} src={logo} alt="Logo" />
        </Link>
      )}
        </div>

        <div className="col-4 d-flex justify-content-center align-items-center ">
          <Link to="/email-form">
            <button> Contact Us</button>
          </Link>
        </div>
      </div>
    </>
  );
}
